import {
  FileOutlined, FilePdfOutlined, FileWordOutlined, FileExcelOutlined,
  FileTextOutlined, FileImageOutlined, FilePptOutlined
} from "@ant-design/icons";

// Returns the file icon depending on the extension of the document
export const getIconForFileType = (type, size = 18) => {
  const baseStyle = {
    display: "block",
    fontSize: size,
    lineHeight: 1.5,
  };

  switch (type?.toLowerCase()) {
    case "image":
      return <FileImageOutlined style={{ ...baseStyle, color: "#e67e22" }} />;
    case "pdf":
      return <FilePdfOutlined style={{ ...baseStyle, color: "#e74c3c" }} />;
    case "docx":
      return <FileWordOutlined style={{ ...baseStyle, color: "#3498db" }} />;
    case "xlsx":
      return <FileExcelOutlined style={{ ...baseStyle, color: "#2ecc71" }} />;
    case "pptx":
      return <FilePptOutlined style={{ ...baseStyle, color: "#de4f3a" }} />;
    case "txt":
      return <FileTextOutlined style={{ ...baseStyle, color: "#f1c40f" }} />;
    default:
      return <FileOutlined style={{ ...baseStyle, color: "#95a5a6" }} />;
  }
};

// Reads type of file and calls function to get file icon with the extension
export const renderFileIcon = (type, size = 18) => {
  if (!type) return false;

  let extension = "";

  if (type) {
    switch (true) {
      case type.startsWith("image/") || /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(type):
        extension = "image";
        break;
      case type === "application/pdf" || /\.pdf$/i.test(type):
        extension = "pdf";
        break;
      case type === "application/msword"
        || type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        || /\.(doc|docx)$/i.test(type):
        extension = "docx";
        break;
      case type === "application/vnd.ms-excel"
        || type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        || /\.(xls|xlsx)$/i.test(type):
        extension = "xlsx";
        break;
      case type === "application/vnd.ms-powerpoint"
        || type === "application/vnd.openxmlformats-officedocument.presentationml.presentation"
        || /\.(ppt|pptx)$/i.test(type):
        extension = "pptx"
        break;
      default:
        extension = type.split("/")[1] || "txt";
        break;
    }

    return getIconForFileType(extension, size);
  }
};